import dayjs from 'dayjs'
import { NotificationItem } from '../components/types'

/**
 * Compares two notification dates for sorting in descending order (newest first)
 * @param {NotificationItem} a - First notification to compare
 * @param {NotificationItem} b - Second notification to compare
 * @returns {number} -1 if a is newer, 1 if b is newer, 0 if equal
 */
export const sortByDate = (
  a: NotificationItem,
  b: NotificationItem
): number => {
  const aDate = dayjs(a.created_at)
  const bDate = dayjs(b.created_at)

  if (aDate.isAfter(bDate)) {
    return -1
  }
  if (aDate.isBefore(bDate)) {
    return 1
  }
  return 0
}

/**
 * Checks if a date string represents today
 * @param {string} dateString - ISO date string to check
 * @returns {boolean} True if the date is today
 */
export const isToday = (dateString: string): boolean => {
  return dayjs(dateString).isSame(dayjs(), 'day')
}

/**
 * Groups notifications into TODAY and EARLIER sections based on creation date
 * @param {NotificationItem[]} notifications - Array of notification objects
 * @returns {Object} Object with todayNotifications and earlierNotifications arrays
 */
export const groupNotificationsByDate = (
  notifications: NotificationItem[]
): {
  todayNotifications: NotificationItem[]
  earlierNotifications: NotificationItem[]
} => {
  const sorted = notifications.sort(sortByDate)

  const todayNotifications = sorted.filter((notification) =>
    isToday(notification.created_at)
  )

  const earlierNotifications = sorted.filter(
    (notification) => !isToday(notification.created_at)
  )

  return { todayNotifications, earlierNotifications }
}
